const en = {
    translation: {
        // Shown over the editor while the canvas initializes.
        loading: 'Loading…',
        // Browser-tab titles (document.title), one per page. Rendered as
        // "<value> | StitchPress"; editor pages prepend the open document's
        // name ("My Shawl | Crochet editor | StitchPress").
        pageTitle: {
            home: 'Home',
            crochetGallery: 'Crochet',
            knitGallery: 'Knit',
            patternGallery: 'Patterns',
            crochetEditor: 'Crochet editor',
            knitEditor: 'Knit editor',
            patternEditor: 'Pattern editor',
            tryCrochet: 'Try crochet',
            tryKnit: 'Try knit',
            settings: 'Settings',
            licenses: 'Open source licenses',
            privacy: 'Privacy Policy',
            terms: 'Terms of Service',
            whatsNew: "What's new",
            crochetIcons: 'Crochet icons',
            iconHandoff: 'Icon handoff',
            signIn: 'Sign in',
            signUp: 'Sign up',
            waitlist: 'Waitlist',
        },
        settings: {
            label: 'Settings',
            info: 'Info',
            apply: 'Apply',
            discard: 'Discard',
            applying: 'Applying…',
            saved: 'Settings saved',
            customCursor: 'Custom cursor',
            inputMode: {
                label: 'Input mode',
                mouse: 'Keyboard + Mouse',
                trackpad: 'Trackpad',
            },
            fontSize: {
                label: 'Font size',
                small: 'Small',
                medium: 'Medium',
                large: 'Large',
                'x-large': 'Extra large',
                'xx-large': 'Extra extra large',
            },
            bentoRadius: {
                label: 'Tray corners',
                description: 'How rounded the editor panels are: the canvas, the header bar, and the properties column.',
                none: 'Square',
                small: 'Slight',
                medium: 'Medium',
                large: 'Round',
                'x-large': 'Extra round',
            },
            canvasGrid: {
                label: 'Canvas grid',
                off: 'Off',
                dots: 'Dots',
                lines: 'Lines',
                ruler: 'Ruler',
                snapToGrid: 'Snap to grid',
            },
            canvasBackground: {
                label: 'Canvas background',
                paper: 'Paper',
                white: 'White',
                linen: 'Linen',
                stone: 'Stone',
                charcoal: 'Charcoal',
                night: 'Night',
                custom: 'Custom color',
                saturation: 'Saturation and brightness',
                hue: 'Hue',
                hex: 'Hex color',
            },
            grabMode: {
                label: 'G-key grab',
                moveOnly: 'Move only',
                allDrags: 'Any drag',
            },
            overlays: {
                label: 'Overlays',
                roundNumbers: 'Round numbers',
                stitchOrder: 'Stitch order',
                guides: 'Guides',
            },
        },
        diagrams: {
            title: 'My diagrams',
            newDiagram: 'New diagram',
            untitled: 'Untitled',
            notFound: 'Diagram not found',
            loadFailed: 'Could not load this diagram — it was left untouched',
            createFailed: 'Could not create a new diagram',
            saveStatus: {
                saving: 'Saving…',
                saved: 'Saved',
                error: 'Couldn’t save',
                tooLarge: 'Too large to sync — saved on this device only',
                synced: 'Synced',
                syncing: 'Syncing…',
                offline: 'Offline — saved on this device',
            },
            save: 'Save',
            lastSavedToday: 'Last saved today at {{time}}',
            lastSavedOn: 'Last saved {{date}} at {{time}}',
            syncedToday: 'Synced today at {{time}}',
            syncedOn: 'Synced {{date}} at {{time}}',
            conflict: 'Changed on another device — reload to get the latest',
            offlineList: 'Offline — showing this device’s copies',
            storageUnavailable: 'Local storage is unavailable — changes won’t be saved',
            listFailed: 'Could not load your diagrams',
            empty: 'No diagrams yet — create your first one',
            renameLabel: 'Diagram name',
            rename: 'Rename',
            delete: 'Delete',
            deleteTitle: 'Delete diagram?',
            deleteBody: '“{{name}}” will be deleted permanently.',
            cancel: 'Cancel',
            confirmDelete: 'Delete',
            discardTitle: 'Discard your unsynced changes?',
            discardBody: '“{{name}}” was deleted on another device. Your unsynced changes here will be lost — this can’t be undone.',
            actionsMenu: 'Diagram actions',
            renameFailed: 'Could not rename the diagram',
            deleteFailed: 'Could not delete the diagram',
            deletedElsewhere: 'Deleted on another device',
            deletedElsewhereBody: 'You have unsynced changes here.',
            keepAsCopy: 'Keep as copy',
            discard: 'Discard',
            keepAsCopyFailed: 'Could not keep a copy',
            discardFailed: 'Could not discard',
            openElsewhere: 'This diagram is open in another tab — changes may conflict',
            aiEditing: 'AI editing…',
            updatedElsewhere: 'This diagram was updated in another session',
            deletedTitle: 'This diagram was deleted',
            deletedBody: '“{{name}}” was deleted on another device. You have changes here that were never synced. Keeping it saves your version as a new diagram — the original can’t be restored.',
            deletedKeep: 'Keep as new diagram',
            deletedDiscard: 'Discard & close',
            deletedBodyOpenCopy: '“{{name}}” was deleted on another device. You can keep this device’s copy as a new diagram — the original can’t be restored.',
            syncConflictTitle: 'Your offline changes weren’t synced',
            syncConflictBody: '“{{name}}” changed on another device while this one was offline, so your changes here were never saved to it. Keep them as a new diagram, or discard them.',
            syncConflictKeep: 'Keep as new diagram',
            syncConflictDiscard: 'Discard my changes',
            syncUnavailable: 'Live sync is unavailable for this diagram right now — changes are saved on this device',
            syncLoadFailed: 'Couldn’t open this diagram — live sync didn’t connect. Check your connection and try again.',
            // Archive: an archived diagram is read-only and takes none of the free plan's active slots.
            archive: 'Archive',
            archiveDone: '“{{name}}” moved to Archived',
            archiveFailed: 'Could not archive the diagram',
            archivedTitle: 'Archived',
            archivedEmpty: 'Nothing archived. Archived diagrams stay here, read-only, and free up an active slot.',
            unarchive: 'Unarchive',
            unarchiveDone: '“{{name}}” is active again',
            unarchiveFailed: 'Could not unarchive the diagram',
            // Badge on a card that exists on this device only: the account has never received it.
            localOnly: 'Only on this device',
            // Under that badge when the account is at its free limit, which is why the upload was refused.
            localOnlyOverLimit: 'Not saved to your account: over the free limit',
        },
        sharing: {
            menuItem: 'Share',
            dialogTitle: 'Share “{{name}}”',
            linkSection: 'Link',
            createLink: 'Create link',
            linkActive: 'Anyone with the link can view',
            copyLink: 'Copy link',
            linkCopied: 'Link copied',
            rotateLink: 'Reset link',
            revokeLink: 'Turn off',
            linkHidden: 'This link was created before URLs were stored, so it can’t be shown — reset the link to get a fresh URL.',
            peopleSection: 'People',
            emailPlaceholder: 'Email address',
            invite: 'Invite',
            pendingBadge: 'Pending',
            invitePending: 'No account with that email yet — they’ll get access when they sign in with it.',
            removePerson: 'Remove',
            allowCopy: 'Viewers can save a copy',
            requestFailed: 'Sharing request failed — try again',
            loading: 'Loading sharing settings…',
            viewOnly: 'View only',
            saveCopy: 'Save a copy',
            copySaved: 'Saved to your diagrams',
            copyForbidden: 'The owner turned off copying for this diagram',
            copyFailed: 'Couldn’t save a copy — try again',
            signInToCopy: 'Sign in to save a copy',
            linkUnavailable: 'This share link is no longer available',
            sharedNotFound: 'This shared diagram is no longer available',
            sharedWithMe: 'Shared with me',
            // Menu entry on an archived card: it opens the dialog to review or reduce sharing.
            menuItemArchived: 'Sharing',
            archivedNote: 'This diagram is archived, so sharing can only be reduced: you can turn the link off, remove people and stop copies. Unarchive it to share it further.',
        },

        // Anonymous /try editors ("taste version") — chrome and sign-up wall.
        tryEditor: {
            defaultName: {
                crochet: 'My first crochet chart',
                knitting: 'My first knit chart',
            },
            signUpCta: 'Sign up — it’s free',
            wall: {
                title: {
                    export: 'Sign up free to export',
                    share: 'Sign up free to share',
                    newDiagram: 'Sign up free to create more',
                },
                body: 'Your work comes with you — everything you made here will be waiting in your account.',
                cta: 'Sign up free',
                dismiss: 'Keep editing',
            },
            // Toast shown once, right after sign-in/sign-up, when there was
            // try-editor work to bring into the new account. Silent when
            // there was nothing to claim.
            claimed: 'Your work was added to your account.',
        },

        // Plan limits. The limit dialog opens when a free account is out of active diagrams; the upgrade dialog
        // opens for a feature that is Pro only. Both offer checkout only when it can be bought.
        billing: {
            limit: {
                title: "You've reached the free limit",
                // {{limit}} is the plan's number of active diagrams.
                body: 'The free plan keeps {{limit}} active diagrams. Archive one to make room. Archived diagrams stay in your account, read-only, and you can restore them when you have room.',
                // For when the plan hasn't loaded yet (a server refusal can arrive first).
                bodyNoLimit:
                    "You've used all the active diagrams on the free plan. Archive one to make room. Archived diagrams stay in your account, read-only, and you can restore them when you have room.",
                archive: 'Archive',
                // Spoken name of a row's button, so a screen reader hears which diagram it acts on.
                archiveNamed: 'Archive “{{name}}”',
                archiveFailed: 'Could not archive the diagram. Please try again.',
                loading: 'Loading your diagrams…',
                // In place of the list when none of the diagrams can be archived from here (for example, they are
                // saved only on this device and have not reached the account yet).
                empty: 'There are no diagrams in your account to archive yet. Diagrams saved only on this device can be archived once they upload.',
                kind: {
                    crochet: 'Crochet',
                    knitting: 'Knit',
                },
                dismiss: 'Not now',
                checkout: 'Get Pro',
                proUnavailable: "Pro isn't available yet.",
            },
            // Save-status pill when the account refused a save (402). The edit is kept on this device.
            saveStatus: {
                overLimit: 'Saved on this device — over the free limit',
                proRequired: 'Saved on this device — patterns need Pro',
            },
            upgrade: {
                patternComposer: {
                    title: 'Pattern documents are a Pro feature',
                    body: 'Upgrade to Pro to create and edit pattern documents. Patterns you already have stay available to view and print.',
                },
                dismiss: 'Not now',
                checkout: 'Get Pro',
                proUnavailable: "Pro isn't available yet.",
            },
        },
        patterns: {
            title: 'My patterns',
            newDiagram: 'New pattern',
            untitled: 'Untitled',
            notFound: 'Pattern not found',
            loadFailed: 'Could not load this pattern — it was left untouched',
            needsNewer: {
                title: 'This pattern needs a newer {{appName}}',
                body: "It was saved by a newer version of the app. Reload to update — your pattern is safe and hasn't been changed.",
                reload: 'Reload',
                back: 'Back to patterns',
            },
            createFailed: 'Could not create a new pattern',
            saveStatus: {
                saving: 'Saving…',
                saved: 'Saved',
                error: 'Couldn’t save',
                tooLarge: 'Too large to sync — saved on this device only',
            },
            save: 'Save',
            lastSavedToday: 'Last saved today at {{time}}',
            lastSavedOn: 'Last saved {{date}} at {{time}}',
            conflict: 'Changed on another device — reload to get the latest',
            offlineList: 'Offline — showing this device’s copies',
            storageUnavailable: 'Local storage is unavailable — changes won’t be saved',
            listFailed: 'Could not load your patterns',
            empty: 'No patterns yet — create your first one',
            renameLabel: 'Pattern name',
            rename: 'Rename',
            delete: 'Delete',
            deleteTitle: 'Delete pattern?',
            deleteBody: '“{{name}}” will be deleted permanently.',
            cancel: 'Cancel',
            confirmDelete: 'Delete',
            discardTitle: 'Discard your unsynced changes?',
            discardBody: '“{{name}}” was deleted on another device. Your unsynced changes here will be lost — this can’t be undone.',
            actionsMenu: 'Pattern actions',
            renameFailed: 'Could not rename the pattern',
            deleteFailed: 'Could not delete the pattern',
            deletedElsewhere: 'Deleted on another device',
            deletedElsewhereBody: 'You have unsynced changes here.',
            keepAsCopy: 'Keep as copy',
            discard: 'Discard',
            keepAsCopyFailed: 'Could not keep a copy',
            discardFailed: 'Could not discard',
            // Badge on a card that exists on this device only: the account has never received it.
            localOnly: 'Only on this device',
            // Banner in the pattern editor for a free account, which can view and print its patterns but not edit
            // them. Next to the readOnlyUpgrade button, which opens the Pro upgrade dialog.
            readOnlyBanner: 'View only: editing patterns is part of Pro. You can still print this one.',
            readOnlyUpgrade: 'Upgrade',
        },
        info: {
            title: 'About',
            version: 'Version',
            environment: 'Environment',
            build: 'Build',
            licensesLink: 'Open source licenses',
            // The offline app's About block (installed build, licence, update link).
            offline: {
                installedVersion: 'Installed version',
                installedOn: 'Installed on',
                licence: 'License ID',
                checkForUpdates: 'Check for updates',
                notInstalled: 'No install information found on this device.',
                backupNote: "Your browser may clear this app's data when space runs low. Back up your work.",
                // Right after the note: the link to Settings → Your data, where Export all is.
                backupLink: 'Export all',
                // Safari Dock and iOS Home Screen apps cannot be updated from the tab that checked for
                // updates, so the update code is carried over by hand.
                pasteUpdateCode: 'Paste update code',
                applyUpdateCode: 'Update',
                notAnUpdateCode: "That isn't an update code.",
                updateCodeExpired: 'This code has expired. Click Check for updates to get a new one.',
            },
        },
        // Pattern-language text (read with patternT): the running footer preset. Single braces are tokens, not i18next.
        headerFooter: {
            pageOfPages: 'Page {page} of {pages}',
        },
        legend: {
            menuItem: 'Stitches used',
            title: 'Stitches used',
            description: 'Stitch types in this diagram',
            empty: 'No stitches yet',
            increase: 'Increase',
            decrease: 'Decrease',
            roofIncrease: 'Increase (one +)',
            roofDecrease: 'Decrease (one +)',
            clusterStitch: '{{memberCount}}-{{member}} cluster',
            clusterSpace: '{{memberCount}}-{{member}} cluster (in ch-sp)',
            popcornStitch: '{{memberCount}}-{{member}} popcorn',
            popcornSpace: '{{memberCount}}-{{member}} popcorn (in ch-sp)',
        },
        diagramText: {
            menuItem: 'Generate text',
            title: 'Pattern text',
            description: 'Written instructions from this diagram',
            empty: 'Nothing to describe yet',
            copy: 'Copy',
            row: 'Row',
            round: 'Round',
            increase: 'inc',
            decrease: 'dec',
            inChSpace: 'in ch-{{count}} sp',
            clusterLabel: '{{memberCount}}-{{member}} cluster',
            clusterInSpace: 'in ch-sp',
            popcornLabel: '{{memberCount}}-{{member}} popcorn',
            popcornInSpace: 'in ch-sp',
            unassignedRound: 'Some stitches have no assigned round',
            orderUnverified: 'order unverified',
            cross: 'grouped {{stitch}}',
            turningChain: 'turning ch',
            turn: 'turn',
        },
        diagramRounds: {
            panelTitle: 'Rounds',
            roundLabel: 'Round {{n}}',
            unassigned: 'Unassigned',
            stitchCount_one: '{{count}} stitch',
            stitchCount_other: '{{count}} stitches',
            showHalo: 'Highlight this round',
            hideHalo: 'Stop highlighting this round',
            empty: 'No rounds yet',
            collapseAll: 'Collapse all',
            expandAll: 'Expand all',
            expandSection: 'Expand section',
            collapseSection: 'Collapse section',
        },
        viewer: {
            viewOnly: 'View only',
            backToGallery: 'Back to my diagrams',
            storageUnavailable: 'Local storage is unavailable — the diagram can’t be loaded',
            // Banner on the owner's view page of an archived diagram, next to an Unarchive button. Also the
            // editor's save status when the server refuses an edit because the diagram was just archived.
            archivedTitle: 'Archived: read-only',
            archivedBody: 'Unarchive it to edit it again.',
        },

        crochetViewer: {
            inspectorTitle: 'Details',
            typeLabel: 'Stitch',
            roundLabel: 'Round',
            orderLabel: 'Order',
            colorLabel: 'Color',
            multiSelected: '{{count}} stitches selected',
        },
        licenses: {
            title: 'Open source licenses',
            intro: '{{appName}} is built with these open-source projects. Thank you to the people who make them.',
        },
        appearance: {
            title: 'Appearance',
            description: 'Choose your preferred color theme.',
            signInPrompt: 'Sign in to manage your settings.',
            loading: 'Loading settings…',
            saveError: 'Failed to save theme. Please try again.',
            theme: {
                label: 'Theme',
                light: 'Light',
                dark: 'Dark',
                system: 'System',
            },
        },
        settingsPage: {
            title: 'Settings',
            nav: {
                appearance: 'Appearance',
                crochet: 'Crochet',
                account: 'Account',
                billing: 'Billing',
                offlineApp: 'Offline app',
                yourData: 'Your data',
                hotkeys: 'Hotkeys',
                info: 'Info',
                connectAi: 'Connect your AI',
            },
            language: {
                label: 'Language',
            },
            account: {
                manageButton: 'Manage account',
                signedOutPrompt: 'Sign in to view your account.',
                noName: 'Unnamed',
            },
            billing: {
                title: 'Billing',
                intro:
                    'Pro gives you unlimited active diagrams, exports without the {{appName}} badge, the pattern composer, the offline app, and more AI edits each day. You will be taken to our payment provider to complete checkout, then returned here.',
                signInPrompt: 'Sign in to manage billing.',
                checkoutButton: 'Continue to checkout',
                unavailable: 'Checkout is unavailable right now. Please try again later.',
                onPro: "You're on Pro.",
                foundingBadge: 'Founding Designer',
                foundingNote: 'Your plan was granted to you, so there is nothing to pay or cancel.',
                renewsOn: 'Renews on {{date}}.',
                endsOn: 'Access ends on {{date}}.',
                lapsed: 'Your subscription has ended. Your work is all still here; resubscribe to get Pro again.',
                manageButton: 'Manage subscription',
                loadError: 'Could not load your billing details. Please try again later.',
                portalError: 'Could not open the billing portal. Please try again.',
                cancelButton: 'Cancel subscription',
                resumeButton: 'Resume subscription',
                cancelConfirmTitle: 'Cancel your subscription?',
                cancelConfirmBody: "It won't renew. You'll keep access until {{date}}, and you can resume any time before then.",
                cancelConfirmBodyNoDate: "It won't renew. You can resume it any time before it ends.",
                cancelConfirmKeep: 'Keep subscription',
                cancelConfirmAction: 'Cancel subscription',
                cancelled: 'Your subscription has been cancelled.',
                resumed: 'Your subscription has been resumed.',
                cancelError: 'Could not cancel your subscription. Please try again.',
                resumeError: 'Could not resume your subscription. Please try again.',
            },
            offlineApp: {
                title: 'Offline app',
                intro: 'Install {{appName}} on this device and keep working without an internet connection.',
                getButton: 'Get offline app',
                opening: 'Opening…',
                popupBlocked: 'Your browser blocked the install page from opening in a new tab.',
                openInstallPage: 'Open install page',
                // Under the button: what is copied into the offline app on install, and the line of the copy.
                dataCopyNote:
                    'In Chrome and Edge, your diagrams and patterns are copied in when you install. Elsewhere, use Settings → Your data.',
                copying: 'Copying your work to the offline app… {{done}} / {{total}}',
                copied: 'Copied',
                copyFailed: "Couldn't copy. Use Export all, then Import in the offline app.",
                trial: 'The offline app comes with a paid plan.',
                trialConverts: 'It becomes available when your trial converts to a paid plan.',
                subscribe: 'Subscribe to get the offline app',
                signInPrompt: 'Sign in to get the offline app.',
                loadError: 'Could not load your plan details. Please try again later.',
                // One message per way a request for the install link can fail.
                tokenError: {
                    not_entitled: 'Your account does not include the offline app. Subscribe to get it.',
                    trial_not_eligible: 'The offline app comes with a paid plan.',
                    rate_limited: 'Too many attempts. Please wait a moment and try again.',
                    unavailable: 'The offline app is not available right now. Please try again later.',
                    failed: 'Could not open the install page. Please try again.',
                },
            },
            // Settings → Your data: Export all and Import of a .stitchpress file. The sentences of a result are
            // joined with spaces, so each ends with its own full stop.
            yourData: {
                title: 'Your data',
                intro:
                    'Save all your diagrams and patterns to a file, or bring in work from one. Importing never overwrites anything.',
                exportButton: 'Export all',
                importButton: 'Import…',
                exporting: 'Exporting {{done}} / {{total}}…',
                checking: 'Checking {{done}} / {{total}}…',
                importing: 'Importing {{done}} / {{total}}…',
                // The name of an imported copy of an item whose id is already taken.
                importedName: '{{name}} (imported)',
                // Filled into {{diagrams}} / {{patterns}} below.
                count: {
                    diagram_one: '{{count}} diagram',
                    diagram_other: '{{count}} diagrams',
                    pattern_one: '{{count}} pattern',
                    pattern_other: '{{count}} patterns',
                },
                export: {
                    done: 'Exported {{diagrams}} and {{patterns}}.',
                    unreadable: "{{count}} couldn't be read.",
                    imagesMissing_one: "{{count}} image couldn't be included.",
                    imagesMissing_other: "{{count}} images couldn't be included.",
                },
                import: {
                    done: 'Imported {{diagrams}} and {{patterns}}.',
                    doneWithCopies_one: 'Imported {{diagrams}} and {{patterns}} ({{count}} as a copy).',
                    doneWithCopies_other: 'Imported {{diagrams}} and {{patterns}} ({{count}} as copies).',
                    // Diagrams the free plan had no active slot for: they were imported, and are in Archived.
                    archived_one: '{{count}} diagram is archived because your free plan is full.',
                    archived_other: '{{count}} diagrams are archived because your free plan is full.',
                    alreadyHere_one: '{{count}} was already here.',
                    alreadyHere_other: '{{count}} were already here.',
                    needsNewer_one: '{{count}} needs a newer {{appName}}.',
                    needsNewer_other: '{{count}} need a newer {{appName}}.',
                    // Patterns are refused on the free plan, so they are not imported.
                    patternsSkipped_one: '{{count}} pattern was skipped: patterns need Pro.',
                    patternsSkipped_other: '{{count}} patterns were skipped: patterns need Pro.',
                    unreadable: "{{count}} couldn't be read.",
                    tooLarge_one: '{{count}} is too large to sync.',
                    tooLarge_other: '{{count}} are too large to sync.',
                    failed: "{{count}} couldn't be saved.",
                    imagesSkipped_one: "{{count}} image couldn't be imported.",
                    imagesSkipped_other: "{{count}} images couldn't be imported.",
                },
                notABundle: "This isn't a {{appName}} file.",
                tooNew: 'This file was made with a newer {{appName}}. Update to open it.',
                unreachable: "Can't reach {{appName}}. Check your connection and try again.",
                unavailable: 'Storage is unavailable in this browser.',
                exportFailed: "Couldn't export your work. Please try again.",
                importFailed: "Couldn't import this file. Please try again.",
            },
            crochet: {
                defaultSizingTab: 'Default sizing',
                description:
                    'Default sizes for each stitch type. Applied to newly created diagrams only — existing diagrams keep the defaults they were created with.',
                saveError: 'Failed to save sizing defaults. Please try again.',
                signInPrompt: 'Sign in to edit default sizing.',
                loading: 'Loading sizing defaults…',
                typeLabel: 'Stitch type',
                auto: 'Auto',
                resetType: 'Reset this stitch',
                resetAll: 'Reset all',
                barLabel: 'bar {{n}}',
                capAngleFollowingHint: 'Ignored by stitches snapped to a guide while "Follow guide direction" is on.',
                fields: {
                    'top-cap': 'Top cap length',
                    crossbar: 'Crossbar length',
                    crossbar2: 'Crossbar 2 length',
                    crossbar3: 'Crossbar 3 length',
                    hook: 'Hook size',
                    width: 'Width',
                    widthScale: 'Width',
                    capAngle: 'Cap angle',
                    crossbarAngle: 'Crossbar angle',
                    crossbarPos: 'Crossbar position',
                    bodyGapTop: 'Top gap',
                    bodyGapBase: 'Base gap',
                    followTangent: 'Follow guide direction',
                    // Translator note: the reference pattern books call this 併針.
                    roofStyle: 'Increases and decreases: one + for the whole stitch',
                    cap: 'Cap length',
                },
                strokeTab: 'Stroke',
                strokeDescription:
                    'Stroke width and line ends for stitch symbols. Applied to newly created diagrams only — existing diagrams keep their own setting.',
                strokeSaveError: 'Failed to save stroke defaults. Please try again.',
                strokeSignInPrompt: 'Sign in to edit stroke defaults.',
                strokeLoading: 'Loading stroke defaults…',
            },
            connectAi: {
                title: 'Connect your AI',
                intro:
                    'Let Claude or ChatGPT build diagrams alongside you, using the same tools you do, one step at a time. You only need the endpoint below — you’ll sign in with your {{appName}} account, with no client ID or API key to copy.',
                supportedClients:
                    'You can currently connect claude.ai (including the Claude desktop app) and ChatGPT. Claude Code and other AI apps aren’t supported yet.',
                endpointLabel: 'MCP endpoint',
                copy: 'Copy',
                copied: 'Copied to clipboard',
                copyError: 'Couldn’t copy — select the text and copy it manually.',
                claudeAppTitle: 'claude.ai and the Claude desktop app',
                claudeAppStepOpen: 'Go to Settings → Connectors and add a custom connector.',
                claudeAppStepUrl:
                    'Name it {{appName}} and paste the MCP endpoint above as the URL. No OAuth client ID or secret is needed — Claude identifies itself automatically.',
                claudeAppStepConnect: 'Select Connect and sign in with your {{appName}} account.',
                chatgptTitle: 'ChatGPT',
                chatgptStepDevMode:
                    'In ChatGPT’s settings, turn on Developer mode (available on paid plans).',
                chatgptStepCreate:
                    'Create a new app, name it {{appName}}, and paste the MCP endpoint above as its URL. Choose OAuth for authentication — no client ID or secret is needed.',
                chatgptStepConnect: 'Connect the app and sign in with your {{appName}} account.',
                chatgptStepUse: 'In a chat, add {{appName}} from the + menu so ChatGPT can use it.',
                openEditorNote: 'Open the diagram in the editor first — the AI can only edit a diagram that’s currently open.',
                reconnectNote:
                    'Set up {{appName}} with a client ID before? Remove that connection and add it again using the steps above — client IDs are no longer used.',
                privacyNote: 'The AI acts as you, on your diagrams only. It never touches anyone else’s work.',
                signInPrompt: 'Sign in to connect an AI assistant.',
            },
        },
        hotkeysReference: {
            title: 'Hotkeys',
            description: 'Keyboard shortcuts currently in use, grouped by editor.',
            groups: {
                global: 'General',
                crochet: 'Crochet editor',
                annotation: 'Annotation layer',
                grid: 'Knit editor',
                composer: 'Pattern editor',
            },
            keys: {
                space: 'Space',
                drag: 'drag',
                scroll: 'scroll',
                ctrl: 'Ctrl',
                enter: 'Enter',
                esc: 'Esc',
                delete: 'Delete',
                backspace: 'Backspace',
                hold: 'hold',
                doubleClick: 'Double-click',
                arrows: '↑ ↓ ← →',
                shift: 'Shift',
                dragCorner: 'drag a corner handle',
                dragEdge: 'drag an edge handle',
                dragHandle: 'drag the rotate handle',
                dragDraw: 'click-drag with the Line tool',
                dragAnchor: 'drag an anchor handle',
                cmd: 'Cmd',
                pinch: 'pinch',
                middleDrag: 'middle-button drag',
                pageUp: 'Page Up',
                pageDown: 'Page Down',
                click: 'click',
                dragBackground: 'drag on the page background',
            },
            global: {
                save: 'Save',
                commandPalette: 'Open command palette',
                pan: 'Pan the canvas',
                zoom: 'Zoom',
                layerStitch: 'Switch to the stitch layer',
                layerAnnotation: 'Switch to the annotation layer',
            },
            crochet: {
                undo: 'Undo',
                redo: 'Redo',
                copy: 'Copy',
                paste: 'Paste at pointer',
                pasteWithStitches: 'Paste guides with snapped stitches',
                pasteWithStructure: 'Paste guides with stitch structure',
                duplicate: 'Duplicate',
                delete: 'Delete selection',
                grab: 'Move selection (grab)',
                grabAxis: 'Lock grab to the X / Y axis',
                slide: 'Slide selection along guide',
                slideRigid: 'Slide selection rigidly',
                extend: 'Extend selection',
                extendCoarse: 'Extend selection (coarse)',
                shrink: 'Shrink selection',
                shrinkCoarse: 'Shrink selection (coarse)',
                nudge: 'Nudge selection',
                nudgeCoarse: 'Nudge selection (coarse)',
                fillGuide: 'Resize selection to fill guide',
                alignToNormal: 'Align selection to guide normal',
                alignRadially: 'Align selection radially',
                flipHorizontal: 'Flip selection horizontally',
                flipVertical: 'Flip selection vertically',
                toolToggle: 'Switch between stitch and guide tools',
                handleType: 'Cycle bezier handle type',
                link: 'Toggle stitch linking',
                snap: 'Toggle snap to grid',
                scopeBases: 'Pick bases only',
                scopeTops: 'Pick tops only',
                pieMenu: 'Open the pie menu',
                quickAccess: 'Open Quick Access',
                commit: 'Confirm pending action',
                cancel: 'Cancel current action',
                editGuide: 'Edit guide shape (guide tool)',
                exitGuideEdit: 'Exit guide shape editing',
                propertiesPanel: 'Show / hide properties panel',
            },
            annotation: {
                delete: 'Delete selected annotation',
                duplicate: 'Duplicate selected annotation',
                copy: 'Copy selected annotation',
                paste: 'Paste annotation at pointer',
                selectAll: 'Select all annotations',
                nudge: 'Nudge selected annotation',
                nudgeCoarse: 'Nudge selected annotation (coarse)',
                cancel: 'Cancel placement or gesture',
                scale: 'Resize selected annotation',
                stretch: 'Stretch selected annotation along one axis',
                rotate: 'Rotate selected annotation',
                drawLine: 'Draw a connection line',
                moveAnchor: 'Move a line anchor',
                editCurve: 'Edit a shape or label (curve, circle, arc, text)',
                cycleHandle: 'Cycle handle type',
            },
            grid: {
                undo: 'Undo',
                redo: 'Redo',
                copy: 'Copy',
                paste: 'Paste',
                modeToggle: 'Switch between stitch and cell modes',
                grab: 'Move selection (grab)',
                pieMenu: 'Open the pie menu',
                cancel: 'Cancel current action',
            },
            composer: {
                deleteElement: 'Delete the selection',
                deselect: 'Deselect',
                dragWithoutSnap: 'Drag without snapping',
                toggleSnap: 'Toggle snapping',
                bold: 'Bold (text)',
                italic: 'Italic (text)',
                underline: 'Underline (text)',
                undo: 'Undo',
                redo: 'Redo',
                textUndo: 'Undo while typing',
                textRedo: 'Redo while typing',
                zoomIn: 'Zoom in',
                zoomOut: 'Zoom out',
                fitPage: 'Fit page',
                zoom: 'Zoom',
                pan: 'Pan the canvas',
                panScreen: 'Scroll one screen',
                panArrows: 'Scroll (nothing selected)',
                nudge: 'Nudge selection 1 px',
                nudgeLarge: 'Nudge selection 10 px',
                bringForward: 'Bring forward',
                sendBackward: 'Send backward',
                bringToFront: 'Bring to front',
                sendToBack: 'Send to back',
                selectAll: 'Select all on this page',
                addToSelection: 'Add to or remove from selection',
                marquee: 'Select an area',
            },
        },
        commandPalette: {
            placeholder: 'Search editor features…',
            empty: 'No matching features',
            howTo: 'How to use',
            descriptions: {
                global: {
                    pan: 'Hold Space and drag, or scroll, to move around the canvas.',
                    zoom: 'Hold Ctrl and scroll to zoom in and out.',
                },
                crochet: {
                    paste: 'Copy first, then press the paste shortcut — stitches are placed at the mouse pointer.',
                    pasteWithStitches: 'With guides copied in the guide tool, this shortcut also pastes the stitches snapped to them.',
                    pasteWithStructure: 'Like paste with snapped stitches, but also carries the rows worked on top of them.',
                    grab: 'Select stitches, press G, move the mouse, then click or press G again to drop.',
                    grabAxis: 'While grabbing with G, press X to move only horizontally or Y to move only vertically; press the same key again to unlock. A green (X) or red (Y) line shows the locked axis.',
                    slide: 'Select stitches on a guide and press C to slide them along it; click to drop.',
                    slideRigid: 'Like slide, but Shift+C keeps stitch spacing fixed while sliding.',
                    extend: 'With a selection, press ] to extend it by one stitch along the guide.',
                    extendCoarse: 'Shift+] extends the selection by a larger step.',
                    shrink: 'With a selection, press [ to shrink it by one stitch.',
                    shrinkCoarse: 'Shift+[ shrinks the selection by a larger step.',
                    nudge: 'Press an arrow key to move the selected stitches (or, with the guide tool, the selected guides) one pixel. Handles snapped to a guide or attached to another stitch stay put — select just the free handles of such a stitch to nudge them.',
                    nudgeCoarse: 'Shift + arrow moves the selection ten pixels.',
                    scopeBases: 'Hold B while clicking to pick only stitch bases.',
                    scopeTops: 'Hold T while clicking to pick only stitch tops.',
                    pieMenu: 'Hold S to open the pie menu at the pointer, then release on a slice.',
                    quickAccess: 'Press W to open your Quick Access menu at the pointer. To add an action, right-click it in the stitch right-click menu or in this search.',
                    commit: 'Press Enter to confirm a pending increase, decrease, or guide edit.',
                    cancel: 'Press Esc to cancel the current pending action or picking flow.',
                    editGuide: 'With the guide tool, select one guide and press Enter (or double-click) to edit its shape.',
                    exitGuideEdit: 'Press Esc to leave guide shape editing.',
                },
                annotation: {
                    paste: 'On the annotation layer, copy a marker first, then press the paste shortcut — it lands at the mouse pointer.',
                    nudge: 'With a marker selected on the annotation layer, press an arrow key to move it one pixel.',
                    nudgeCoarse: 'Shift + arrow moves the selected marker ten pixels.',
                    cancel: 'Press Esc to drop an armed marker or abort a drag / rotate.',
                    scale: 'Select a marker on the annotation layer and drag one of the four corner handles; the marker scales uniformly about its centre.',
                    stretch: 'Drag one of the four edge handles to stretch the marker along that axis only; the corners keep it proportional.',
                    rotate: 'Select a marker and drag the round handle in front of it to point it in a new direction.',
                    drawLine: 'Pick Line in the left rail, then press on the canvas and drag to the other end; ends near a stitch snap to it and follow it.',
                    moveAnchor: 'Select a line and drag one of its round anchor handles; drop it on a stitch to attach it there.',
                    editCurve: 'With a curve, circle, arc or text label selected, press Enter (or double-click it, or use the inspector’s Edit shape button) to reveal its handles — for a text label, to start typing.',
                    cycleHandle: 'While editing a curve with a handle selected, press T to cycle its type between aligned, vector, and free.',
                },
                grid: {
                    grab: 'Select cells, press G, move the mouse, then click or press G again to drop.',
                    pieMenu: 'Hold S to open the pie menu at the pointer, then release on a slice.',
                    cancel: 'Press Esc to cancel the current action.',
                },
            },
        },
        consent: {
            banner: {
                title: 'We use cookies',
                description:
                    '{{appName}} uses analytics cookies to understand how the app is used and improve it. You can accept, reject, or choose which categories to allow.',
                acceptAll: 'Accept all',
                rejectAll: 'Reject all',
                customize: 'Customize',
                save: 'Save choices',
                privacyLink: 'Privacy & Cookies',
            },
            categories: {
                analytics: {
                    label: 'Analytics',
                    description: 'Usage events and automatic interaction capture that help us improve the app.',
                },
                sessionReplay: {
                    label: 'Session replay',
                    description: 'Records anonymized sessions so we can diagnose issues. More detailed than analytics.',
                },
                errorMonitoring: {
                    label: 'Error monitoring',
                    description: 'Sends crash reports and performance data to Sentry so we can find and fix problems.',
                },
            },
            settings: {
                navLabel: 'Privacy & Cookies',
                title: 'Privacy & Cookies',
                description: 'Control which analytics cookies {{appName}} may use. Saving reloads the page to apply your choice.',
                viewPolicy: 'View the Privacy Policy page',
            },
            privacyPage: {
                title: 'Privacy Policy',
                intro: '{{appName}} uses cookies and similar technologies (including browser local storage) for the purposes below. Strictly necessary items are always active; analytics, session replay, and error monitoring run only with your consent, which you can change at any time.',
                manage: 'Manage cookie preferences',
                policy: {
                    updated: 'Last updated: {{date}}',
                    whoWeAre: {
                        p1: '{{appName}} is a knitting and crochet pattern design app operated by Kinnet Studio ("we", "us"). This privacy policy explains what personal data we collect when you use {{appName}}, how we use it, who we share it with, and the choices you have.',
                        contact: 'Contact us about privacy:',
                    },
                    dataWeCollect: {
                        title: 'Data we collect',
                        p1: 'Account information. When you create an account we receive your email address, display name, and profile picture from our authentication provider, Clerk. If you sign in with a third-party provider such as Google, that provider shares this basic profile information with us; we never receive your password for that provider.',
                        p2: 'Your content. The patterns, charts, and diagrams you create are stored on our servers so they can sync across your devices and, when you choose, be shared with others.',
                        p3: 'Usage and diagnostics data (optional). With your consent, we collect analytics events, anonymized session replays, and error reports to understand how the app is used and to fix problems. These are off by default and controlled from the cookie banner or Settings.',
                        p4: 'Device preferences. Settings such as language, font size, and stitch colors are stored locally in your browser and are not transmitted to us.',
                    },
                    googleUserData: {
                        title: 'Google user data',
                        p1: 'If you sign in with Google, {{appName}} receives only your basic Google profile information — your name, email address, and profile picture — through our authentication provider, Clerk. We do not request access to any other Google services or data (such as Gmail, Drive, or Contacts).',
                        p2: 'We use this information solely to create and secure your {{appName}} account, identify you within the app, and communicate with you about the service.',
                        p3: 'We do not sell Google user data, use it for advertising, or share it with any third party except the service providers listed below, which process it on our behalf to operate {{appName}}.',
                    },
                    howWeUse: {
                        title: 'How we use your data',
                        p1: 'We use your data to provide {{appName}}: authenticating you, storing and syncing your patterns, and enabling the sharing features you choose to use.',
                        p2: 'With your consent, we also use aggregated usage data and error reports to improve the app. We do not sell your personal data or use it for third-party advertising.',
                    },
                    processors: {
                        title: 'Service providers',
                        intro: 'We rely on the following service providers to operate {{appName}}. Each processes data on our behalf and only as needed to provide its service:',
                        items: {
                            clerk: 'Clerk — authentication and account management (email, name, profile picture, sign-in state).',
                            cloudflare: 'Cloudflare — application hosting and storage of your synced content.',
                            statsig: 'Statsig — product analytics and session replay; active only with your consent.',
                            sentry: 'Sentry — crash and error reporting; active only with your consent.',
                            userback: 'Userback — feedback collection; loads only when you open the feedback form.',
                            google: 'Google — sign-in only, if you choose to sign in with Google.',
                        },
                    },
                    retention: {
                        title: 'Data retention & deletion',
                        p1: 'We keep your account data and content for as long as your account exists. When you delete your account, your account data and synced content are deleted from our systems; residual copies in backups are removed on their normal rotation schedule.',
                        p2: 'You can request deletion of your account and data — or a copy of the data we hold about you — at any time by contacting us at the email address above.',
                    },
                    cookies: {
                        title: 'Cookies & local storage',
                    },
                    yourRights: {
                        title: 'Your rights & choices',
                        p1: 'You can withdraw or change your consent to analytics, session replay, and error monitoring at any time using the "Manage cookie preferences" button above or in Settings. Withdrawing consent stops future collection.',
                        p2: 'Depending on where you live, you may also have rights to access, correct, export, or delete your personal data. Contact us at the email address above and we will honor these requests.',
                    },
                    changes: {
                        title: 'Changes to this policy',
                        p1: 'We may update this policy as {{appName}} evolves. Material changes will be announced in the app, and the "Last updated" date above always reflects the current version.',
                    },
                },
                table: {
                    name: 'Name',
                    purpose: 'Purpose',
                    storage: 'Storage',
                },
                storageType: {
                    cookie: 'Cookie',
                    local: 'Local storage',
                    network: 'Sent to Sentry',
                },
                cat: {
                    necessary: {
                        title: 'Strictly necessary',
                        desc: 'Required to sign in and keep the app working, provided by our authentication provider (Clerk). These cannot be turned off.',
                    },
                    functional: {
                        title: 'Functional preferences',
                        desc: 'Remember your settings on this device. First-party only; no tracking.',
                    },
                    analytics: {
                        title: 'Analytics',
                        desc: 'Help us understand usage and improve the app, via our analytics provider (Statsig). Active only with your consent.',
                    },
                    replay: {
                        title: 'Session replay',
                        desc: 'Records anonymized sessions to diagnose issues, via Statsig. Active only with your consent.',
                    },
                    errorMonitoring: {
                        title: 'Error monitoring',
                        desc: 'Captures crash reports and performance data to help us fix problems, via our monitoring provider (Sentry). No persistent cookies are set — data is sent over the network. Active only with your consent.',
                    },
                },
                purpose: {
                    clerkSession: 'Keeps you signed in (authentication).',
                    clerkUat: 'Tracks sign-in state for page routing.',
                    consent: 'Remembers your cookie choices.',
                    lang: 'Your language preference.',
                    fontSize: 'Your interface font-size preference.',
                    bentoRadius: 'Your editor panel corner-rounding preference.',
                    cursor: 'Whether the custom cursor is enabled.',
                    colors: 'Your saved custom stitch colors.',
                    featureGates: "Remembers which app features are turned on, so they don't flicker while loading.",
                    statsigStable: 'Anonymous device identifier for analytics.',
                    statsigSession: 'Groups analytics events into a session.',
                    statsigCache: 'Queued analytics events and cached configuration.',
                    replay: 'Buffers anonymized session-replay recordings.',
                    sentryDiagnostics: 'Crash reports and performance/profiling data sent to Sentry.',
                },
            },
        },
        authFooter: {
            privacy: 'Privacy Policy',
            terms: 'Terms of Service',
            licenses: 'Licenses',
        },
        // Signed-out pages: links out to the marketing site so prospective
        // users can see what the app offers before joining the waitlist.
        authSiteLinks: {
            label: '{{appName}} website',
            prompt: 'New to {{appName}}?',
            landing: 'See what it offers',
            blog: 'Read the blog',
        },
        // Sticky top-center notice, shown only while the UI is in Japanese.
        unproofreadTranslationNotice: {
            message: "The Japanese translation hasn't been proofread yet, so please use it at your discretion. We're working on getting it proofread.",
            close: 'Close',
            // Subtitle under the 日本語 language option; always rendered in Japanese.
            languageOptionHint: 'Translation not yet proofread',
        },
        whatsNew: {
            title: "What's new",
            description: 'The latest improvements to {{appName}}.',
            // Screen-reader text next to the unread dot.
            unreadHint: 'New updates',
            // AppNav trigger's accessible name while the dot shows.
            menuLabelUnread: 'Open navigation menu (new updates)',
            // /try brand-mark button's accessible name while the dot shows.
            titleUnread: "What's new (new updates)",
            openAsPage: 'Open as a page',
            empty: 'No release notes yet.',
            loading: 'Loading…',
            loadError: "Couldn't load these notes.",
            retry: 'Retry',
            languageFallback: 'Not available in {{language}} yet, so this is in English.',
        },
        terms: {
            title: 'Terms of Service',
            updated: 'Last updated: {{date}}',
            intro: {
                p1: 'These terms of service are an agreement between you and Kinnet Studio ("we", "us"), the operator of {{appName}}, a knitting and crochet pattern design app. By creating an account or using {{appName}} you agree to these terms. If you do not agree, please do not use the service.',
                contact: 'Questions about these terms:',
            },
            sections: {
                account: {
                    title: 'Your account',
                    p1: 'You sign in to {{appName}} through our authentication provider, Clerk. Keep your sign-in credentials secure: you are responsible for activity that happens under your account.',
                    p2: 'You must be at least 13 years old to use {{appName}}.',
                },
                yourContent: {
                    title: 'Your content',
                    p1: 'The patterns, charts, and diagrams you create belong to you. These terms do not transfer any ownership of your content to us.',
                    p2: 'So that we can operate {{appName}}, you grant us a worldwide, non-exclusive license to host, store, reproduce, and display your content — solely as needed to provide the service, including sync across your devices and the sharing features you choose to enable.',
                },
                acceptableUse: {
                    title: 'Acceptable use',
                    p1: 'Use {{appName}} only for lawful purposes. Do not upload content that infringes the rights of others, and do not use the service to harass or harm anyone.',
                    p2: 'Do not interfere with or disrupt the service, attempt to access accounts or data that are not yours, or scrape or access the service by automated means other than the interfaces we provide.',
                },
                service: {
                    title: 'The service',
                    p1: 'We may add, change, or remove features of {{appName}} as the service evolves.',
                    p2: 'We may modify, suspend, or discontinue all or part of the service at any time.',
                },
                ip: {
                    title: 'Our intellectual property',
                    p1: 'The {{appName}} application, its design, name, and branding are and remain our property. These terms do not grant you any rights to them beyond using the service. Your content remains yours (see "Your content").',
                },
                termination: {
                    title: 'Termination & assignment',
                    p1: 'You may stop using {{appName}} and delete your account at any time. Deletion of your data follows our privacy policy.',
                    p2: 'We may suspend or terminate your account if you violate these terms.',
                    p3: 'We may assign these terms, and the agreements they create, to a successor or affiliated entity in connection with a reorganization or a transfer of the service. Your rights under these terms are personal to you and may not be assigned.',
                },
                disclaimers: {
                    title: 'Disclaimers',
                    p1: 'To the fullest extent permitted by law, {{appName}} is provided "as is" and "as available", without warranties of any kind, express or implied — including fitness for a particular purpose, and uninterrupted or error-free operation.',
                },
                liability: {
                    title: 'Limitation of liability',
                    p1: 'To the fullest extent permitted by law, our total liability for any claims arising out of or relating to the service is limited to the amount you paid us for the service in the twelve months before the claim arose. We are not liable for indirect, incidental, or consequential damages, including loss of data.',
                },
                law: {
                    title: 'Governing law',
                    p1: 'These terms are governed by the laws of Taiwan (R.O.C.), and any disputes arising from them or from your use of {{appName}} shall be submitted to the courts of Taiwan.',
                },
                changes: {
                    title: 'Changes to these terms',
                    p1: 'We may update these terms as {{appName}} evolves. The "Last updated" date above always reflects the current version — please check this page from time to time. Continuing to use the service after a change takes effect means you accept the updated terms.',
                },
            },
        },

        waitlist: {
            heading: '{{appName}} is invite-only',
            subtext:
                'Join the waitlist and we’ll email you when a spot opens up.',
        },
        // Toolbar
        contextMenu: {
            atCell: 'Cell (row {{row}}, column {{col}})',
            selectionArea:
                'Selection: {{rowCount}} rows × {{colCount}} columns (rows {{r1}}–{{r2}}, columns {{c1}}–{{c2}})',
            copyPattern: 'Copy the pattern',
            pastePattern: 'Paste the pattern',
            clipboardLoading: 'Clipboard: checking…',
            clipboardEmpty: 'Clipboard: empty',
            clipboardHasPattern: 'Clipboard: has a pattern from the editor',
            clipboardHasOther: 'Clipboard: has other text',
            clipboardUnavailable: 'Clipboard: not readable (permission or browser)',
            copyReplacesClipboard:
                'Copy will replace the current clipboard contents.',
            fillRange: 'Fill with current stitch',
            fillColorRange: 'Fill with current color',
            clearRange: 'Clear cells in selection',
            placeCellHere: 'Place cell here',
            startNewPieceHere: 'Start new piece here',
            removeCellHere: 'Remove cell',
        },

        toolbar: {
            placeTool: 'Place',
            placeToolDescription: 'Place stitches on the grid',
            selectTool: 'Select',
            selectToolDescription:
                'Select cells. Click and drag for a range. Shift+click extends from the last anchor.',
            prependRow: 'Insert {{count}} row(s) above',
            appendRow: 'Add {{count}} row(s) below',
            removeFirstRow: 'Remove first {{count}} row(s)',
            removeLastRow: 'Remove last {{count}} row(s)',
            prependColumn: 'Insert {{count}} column(s) to the left',
            appendColumn: 'Add {{count}} column(s) to the right',
            removeFirstColumn: 'Remove first {{count}} column(s)',
            removeLastColumn: 'Remove last {{count}} column(s)',
            stitchPicker: 'Choose Stitch',
            eraseTool: 'Erase',
            eraseToolDescription: 'Erase stitches from the grid',
            stitchColor: 'Stitch color',
            stitchColorStandard: 'Standard',
            stitchColorCustomHint: 'Custom (right-click a swatch to change)',
            stitchColorCustomSlot: 'Custom slot {{n}}',
            stitchColorEditingSlot: 'Editing slot {{n}}',
            stitchColorBack: 'Back to swatches',
            stitchColorHue: 'Hue',
            stitchColorSaturation: 'Saturation and value',
            stitchColorHex: 'Hex color value',
            stitchMode: 'Stitch mode',
            cellMode: 'Cell mode',
            stitchModeShort: 'Stitch',
            cellModeShort: 'Cell',
            cellModeDescription: 'Shape the fabric: add or remove cells of the chart',
            stitchModeDescription: 'Stitch into existing cells',
            inputMode: {
                mouse: 'Mouse',
                trackpad: 'Trackpad',
                switchToTrackpad:
                    'Using keyboard + mouse for pan and zoom. Click to switch to trackpad.',
                switchToMouse:
                    'Using the trackpad for pan and zoom. Click to switch to keyboard + mouse.',
            },
        },

        export: {
            button: 'Export range',
            panelTitle: 'Export options',
            dragHint: 'Drag a rectangle to export, or press Esc to cancel',
            includeGrid: 'Background grid',
            includeGuides: 'Guides',
            includeLabels: 'Row/column labels',
            includeLabelsCrochet: 'Round/order labels',
            transparent: 'Transparent background',
            quality: 'Quality',
            cancel: 'Cancel',
            download: 'Download PNG',
            exporting: 'Exporting…',
            failed: 'Export failed. Please try again.',
        },

        diagramEmbed: {
            title: 'Insert diagram',
            frameTitle: 'Diagram framing',
            loading: 'Loading diagram…',
            noDiagrams: 'No saved diagrams yet.',
            kindCrochet: 'Crochet',
            kindKnitting: 'Knit',
            use: 'Use this view',
            refresh: 'Refresh from diagram',
            tooLarge: 'This selection is too large to insert. Try a lower quality or a smaller range.',
            renderFailed: 'Could not render the diagram. Please try again.',
            insertFailed: 'Could not insert the diagram. Please try again.',
            emptyDiagram: 'That diagram is empty — nothing to insert.',
            diagramUnavailable: 'That diagram is no longer available.',
            frameTimeout: 'The diagram viewer did not load. Please try again.',
        },

        strokeStyle: {
            label: 'Stroke',
            width: 'Width',
            cap: {
                label: 'Line ends',
                round: 'Round',
                square: 'Square',
                butt: 'Flat',
            },
            inherited: 'Diagram default',
            mixed: 'Mixed',
            resetToDiagram: 'Reset to diagram',
            resetToFactory: 'Reset',
            widthValue: '{{value}}×',
        },

        crochetInspector: {
            ringHeading: 'Ring',
            lineGuideHeading: 'Line guide',
            circleGuideHeading: 'Circle guide',
            centerSymbolLabel: 'Center symbol',
            centerSymbol: {
                'none': 'None',
                'magic-ring': 'Magic ring',
                'wa': 'わ',
            },
            bezierGuideHeading: 'Bezier guide',
            bezierClose: 'Close loop',
            bezierOpen: 'Open curve',
            bezierAddAnchor: 'Add anchor',
            bezierRemoveAnchor: 'Remove anchor',
            bezierAnchorHandles: 'Selected anchor handles',
            bezierHandle_aligned: 'Aligned',
            bezierHandle_vector: 'Vector',
            bezierHandle_free: 'Free',
            bezierHandleSide_left: 'Left',
            bezierHandleSide_right: 'Right',
            tbcHeading: 'Stitch',
            tbcsHeading: 'Stitches',
            panelTitle: 'Inspector',
            emptyState: 'Select a stitch or guide to see its properties.',
            collapse: 'Collapse panel',
            expand: 'Expand panel',
            close: 'Close panel',
            groupOrder: {
                title: 'Group order',
                flip: 'Flip front/back',
                ungroup: 'Ungroup',
                detachMember: 'Detach from group',
                bringToFront: 'Bring to front',
                bringForward: 'Bring forward',
                sendBackward: 'Send backward',
                sendToBack: 'Send to back',
            },
            perTopHeading: 'Per-top',
            roundLabel: 'Round',
            ringRadius: 'Radius: {{radius}}',
            setAllTops: 'Set all tops',
            multiSelected: '{{count}} stitches selected',
            editShape: 'Edit shape',
            guidesSelected: '{{count}} guides selected',
            setRoundForSelection: 'Set round for all',
            clearRound: 'Clear',
            topUserRoundLabel: 'Override',
            orderLabel: 'Order',
            setOrderForSelection: 'Set order for all',
            orderNoRound: 'no round',
            sourceMixed: 'mixed',
            sourceFree: 'free',
            sourceDisagreement: 'conflict',
            sourceCycle: 'cycle',
            source: {
                user: 'user',
                guide: 'guide',
                inferred: 'inferred',
            },
            verticalLinksTitle: 'Vertical links',
            verticalParentsLabel: 'Parents',
            verticalChildrenLabel: 'Children',
            verticalNoLinks: 'No vertical links',
            verticalUnlink: 'Unlink',
            verticalShowOnCanvas: 'Show',
            verticalHideOnCanvas: 'Hide',
            verticalLegendParent: 'parent end',
            verticalLegendChild: 'child end',
            verticalIssueRoundOrder: 'Parent round is later than child',
            verticalIssueMixed: 'Endpoint has no single round',
            spaceTitle: 'Space',
            spaceChainCount: 'ch-{{n}} space',
            spaceNoGuide: 'No worked-into guide',
            spaceGuideLabel: 'Guide',
            spaceSetGuide: 'Set worked-into guide…',
            spaceClearGuide: 'Clear guide',
            spaceDissolve: 'Dissolve space',
            // Shown when picking a worked-into guide lands on one already
            // targeted by another space — the pick is rejected, not stolen.
            spaceGuideTaken: 'That guide is already the target of another space.',
            // Same pick, rejected because one of this space's own chains is
            // snapped to that guide/ring (the target follows the chains).
            spaceGuideChainSnapped: 'A chain in this space is snapped to that guide, so it can’t be the space’s target.',
            sectionRoundOrder: 'Round & order',
            sectionColor: 'Color',
            colorMixed: 'Mixed colors',
            sectionFollowTangent: 'Guide tangent',
            followTangent: {
                label: 'Follow guide tangent',
                hint: 'Cap angle is locked while following.',
                on: 'On',
                off: 'Off',
                mixed: 'Mixed',
            },
            sectionRoofStyle: 'Increase / decrease symbol',
            roofStyle: {
                label: 'One + for the whole stitch',
                hint: 'Legs meet at one point with a single + between them.',
                on: 'One +',
                off: 'One + per leg',
                mixed: 'Mixed',
            },
            // "Rect size" names the stitch family it applies to (slip stitch,
            // chain, single crochet + variants) — the dc/hdc/tr family is sized
            // by its per-part knobs instead, and never shows this section.
            rectSizeHeading: 'Rect size',
            rectWidthLabel: 'Width',
            rectHeightLabel: 'Height',
            rectSizeValue: '{{value}}×',
            rectSizeMixed: 'mixed',
            rectHeightPinned: 'Both ends are attached to a guide, so the height is fixed. Detach one to resize.',
            cluster: {
                memberType: 'Member stitch',
                count: 'Count',
                countMinus: 'Decrease cluster count',
                countPlus: 'Increase cluster count',
                into: {
                    label: 'Worked into',
                    stitch: 'A stitch',
                    space: 'A space',
                },
            },
            popcorn: {
                memberType: 'Member stitch',
                count: 'Count',
                countMinus: 'Decrease popcorn count',
                countPlus: 'Increase popcorn count',
                into: {
                    label: 'Worked into',
                    stitch: 'A stitch',
                    space: 'A space',
                },
            },
        },
        propertiesColumn: {
            collapse: 'Hide panel',
            resize: 'Resize panel',
            expand: 'Show panel',
        },
        headerTray: {
            collapse: 'Hide header',
            expand: 'Show header',
        },
        commandKeyToggle: {
            label: 'Add to selection',
            tooltipOn: 'Add to selection is on — tap items to add or remove them, or drag to toggle a region. Tap to turn off.',
            tooltipOff: 'Add to selection — tap items to add or remove them, or drag to toggle a region.',
        },
        altKeyToggle: {
            label: 'Alt actions',
            tooltipOn: 'Alt actions are on — tap a snapped handle to switch which one is selected, or tap a stitch body to select all its handles. Tap to turn off.',
            tooltipOff: 'Alt actions — tap a snapped handle to switch which one is selected, or tap a stitch body to select all its handles.',
        },

        crochetStepper: {
            extend: 'Lengthen',
            shrink: 'Shorten',
        },

        quickAccess: {
            title: 'Quick Access',
            empty: 'Right-click any menu item to add it here.',
            add: 'Add to Quick Access',
            remove: 'Remove from Quick Access',
        },

        // Crochet editor right-click (context) menu
        crochetContextMenu: {
            addRingAbove: 'Add ring above',
            addRingBelow: 'Add ring below',
            finishPlacement: 'Finish',
            cancelPlacement: 'Cancel',
            removeRing: 'Remove ring',
            deleteGuide: 'Delete guide',
            addStitchesAlongGuide: 'Add stitches…',
            selectAllHandlesOnGuide: 'Select all handles',
            selectAllTopsOnGuide: 'Select all tops',
            selectAllBasesOnGuide: 'Select all bases',
            doneEditing: 'Done editing',
            editBezier: 'Edit bezier curve',
            distributeBasesEvenly: 'Distribute bases evenly',
            distributeTopsEvenly: 'Distribute tops evenly',
            distributeBothEvenly: 'Distribute both evenly',
            spreadBasesAcrossGuide: 'Spread bases across a guide…',
            spreadTopsAcrossGuide: 'Spread tops across a guide…',
            spreadBasesBetweenPoints: 'Spread bases between two points…',
            spreadTopsBetweenPoints: 'Spread tops between two points…',
            spreadBetweenPointsHintStart: 'Click a point on a guide to start. Click a stitch to stop beside it.',
            spreadBetweenPointsHintEnd: 'Click where the spread ends.',
            projectBasesOntoGuide: 'Project bases onto a guide…',
            projectTopsOntoGuide: 'Project tops onto a guide…',
            projectBothOntoGuide: 'Project both onto a guide…',
            slideAlongGuide: 'Slide along guide',
            slideAlongGuideKeepOrientation: 'Slide along guide (keep orientation)',
            distributeSnappedBasesBetween: 'Distribute snapped bases between endpoints',
            distributeSnappedTopsBetween: 'Distribute snapped tops between endpoints',
            distributeSnappedBothBetween: 'Distribute snapped bases and tops between endpoints',
            rewidthToFillGuide: 'Rewidth to fill guide',
            alignRadially: 'Align radially',
            alignRadiallyToBase: 'Align radially to base',
            alignRadiallyToTop: 'Align radially to top',
            alignToNormal: 'Align to normal',
            alignToBaseNormal: 'Align to base normal',
            alignToTopNormal: 'Align to top normal',
            alignDirection: 'Align direction',
            guide: 'Guide',
            detach: 'Detach',
            link: 'Link',
            align: 'Align',
            horizontal: 'Horizontal',
            vertical: 'Vertical',
            top: 'Top',
            bottom: 'Bottom',
            left: 'Left',
            right: 'Right',
            distribute: 'Distribute',
            horizontally: 'Horizontally',
            vertically: 'Vertically',
            addStitchOnTop: 'Add stitch on top…',
            addIncreaseOnTop: 'Add increase on top…',
            addStitchUnder: 'Add stitch under…',
            addIncreaseUnder: 'Add increase under…',
            singleCrochet: 'Single crochet',
            nTops: '{{count}} tops',
            resetGap: 'Reset gap',
            detachFromParent: 'Detach from parent stitch',
            detachFromParents: 'Detach from parent stitches ({{count}})',
            breakConnectionHere: 'Break connection here',
            detachHandleFromGuide: 'Detach handle from guide',
            detachHandlesFromGuides: 'Detach {{count}} handles from guides',
            detachBaseFromGuide: 'Detach base from guide',
            detachBasesFromGuides: 'Detach {{count}} bases from guides',
            detachTopFromGuide: 'Detach top from guide',
            detachTopsFromGuides: 'Detach {{count}} tops from guides',
            copy: 'Copy',
            pasteHere: 'Paste here',
            sheetTitle: 'Actions',
            back: 'Back',
            // Partial-result toasts after an align/distribute action.
            toastAligned: 'Aligned {{applied}} — {{skipped}} skipped (snapped to a guide or attached).',
            toastAlignedNone: 'No handles aligned — {{skipped}} skipped (snapped to a guide or attached).',
            toastDistributed: 'Distributed {{applied}} — {{skipped}} skipped (snapped to a guide or attached).',
            toastDistributedNone: 'No handles distributed — {{skipped}} skipped (snapped to a guide or attached).',
            toastRadialAligned: 'Aligned {{applied}} — {{skipped}} skipped (no qualifying snap or guide can’t satisfy the radial direction).',
            toastRadialAlignedNone: 'No stitches aligned — {{skipped}} skipped (no qualifying snap or guide can’t satisfy the radial direction).',
            toastNormalAligned: 'Aligned {{applied}} — {{skipped}} skipped (no qualifying snap or guide can’t satisfy the normal direction).',
            toastNormalAlignedNone: 'No stitches aligned — {{skipped}} skipped (no qualifying snap or guide can’t satisfy the normal direction).',
            flipHorizontal: 'Flip horizontal',
            flipVertical: 'Flip vertical',
            toastFlipped: 'Flipped {{applied}} — {{skipped}} skipped (snapped to a guide or attached).',
            toastFlippedNone: 'Nothing flipped — {{skipped}} skipped (snapped to a guide or attached).',
            toastDirectionAligned: 'Aligned {{applied}} — {{skipped}} skipped (root has no direction or top is guide-snapped).',
            toastDirectionAlignedNone: 'No stitches aligned — {{skipped}} skipped (root has no direction or top is guide-snapped).',
            handleAligned: 'Aligned',
            handleVector: 'Vector',
            handleFree: 'Free',
            linkAsParent: 'Link as parent of…',
            linkAsChild: 'Link as child of…',
            makeGroup: 'Group',
            flipGroup: 'Flip',
            detachFromGroup: 'Detach from group',
            ungroup: 'Ungroup',
            markTurningChain: 'Mark as turning chain',
            removeTurningChain: 'Remove turning chain',
            assignAsSpace: 'Assign as space',
            bringToFront: 'Bring to front',
            bringForward: 'Bring forward',
            sendBackward: 'Send backward',
            sendToBack: 'Send to back',
        },
        crochetGroupsPanel: {
            title: 'Groups',
            empty: 'No groups yet',
            groupLabel: 'Group {{n}}',
            togglePanel: 'Groups',
            highlight: 'Highlight on canvas',
            flip: 'Flip front/back',
            disband: 'Ungroup',
            select: 'Select group',
            cutUnder: 'Break crossed sticks',
        },

        crochetAddStitchesDialog: {
            title: 'Add stitches to guide',
            count: 'Count',
            startAngle: 'Start angle',
            decrement: 'Decrease count',
            increment: 'Increase count',
            stitchType: 'Stitch',
            orient: 'Orient to guide',
            orientOn: 'On',
            orientOff: 'Off',
            snapBy: 'Snap by',
            snapByBase: 'Base',
            snapByTop: 'Top',
            autoWidth: 'Auto width — fill guide',
            autoWidthOn: 'On',
            autoWidthOff: 'Off',
            width: 'Stitch width',
            height: 'Stitch height',
            scaleValue: '{{value}}×',
            lockAspectRatio: 'Lock aspect ratio',
            lockAspectRatioOn: 'On',
            lockAspectRatioOff: 'Off',
            cancel: 'Cancel',
            add: 'Add',
        },

        crochetCombination: {
            modeSingle: 'Single',
            modeCombination: 'Combination',
            textboxLabel: 'Combination',
            textboxPlaceholder: 'e.g. sc, (ch, ch, sc) * 3, dc',
            repeats: 'Repeats',
            summary: '{{combo}} · ×{{repeats}} = {{total}} stitches',
            summaryWithSlots: '{{combo}} · ×{{repeats}} = {{stitches}} stitches ({{slots}} slots)',
            unknownStitch: 'Unknown stitch: {{token}}',
            unbalancedParens: 'Unmatched parenthesis',
            invalidRepeat: 'Invalid repeat count',
            emptyGroup: 'Empty group',
            tooManyStitches: 'Too many stitches',
        },

        editorLayer: {
            group: 'Editor layer',
            stitch: 'Stitch',
            stitchTooltip: 'Stitch layer (1)',
            annotation: 'Annotation',
            annotationTooltip: 'Annotation layer (2)',
            select: 'Select',
            startMarker: 'Start marker',
            endMarker: 'End marker',
            startMarkerTooltip: 'Place a start-of-work marker (hollow triangle)',
            endMarkerTooltip: 'Place an end-of-work marker (solid triangle)',
            line: 'Line',
            lineTooltip: 'Draw a connection line (click-drag; ends snap to stitches)',
            curve: 'Curve',
            curveTooltip: 'Draw a curved connection line (click-drag; ends snap to stitches)',
            circle: 'Circle',
            circleTooltip: 'Place a circle (click; double-click it to drag its center and radius)',
            arc: 'Arc',
            arcTooltip: 'Place an arc (click; double-click it to drag its center, radius and ends)',
            text: 'Text',
            textTooltip: 'Place a text label (click, then type; Escape or the chip finishes)',
        },

        annotationInspector: {
            panelTitle: 'Annotation',
            empty: 'Nothing to inspect on the annotation layer yet.',
            angle: 'Angle (°)',
            width: 'Width (%)',
            height: 'Height (%)',
            delete: 'Delete',
            color: 'Color',
            multi: {
                count_one: '{{count}} annotation selected',
                count_other: '{{count}} annotations selected',
            },
            symbol: {
                start: 'Start marker',
                end: 'End marker',
                path: 'Connection line',
                bezier: 'Curved line',
                circle: 'Circle',
                arc: 'Arc',
                text: 'Text label',
            },
            text: {
                content: 'Text',
                size: 'Size',
                fontFamily: 'Font',
                families: { sans: 'Sans', serif: 'Serif', mono: 'Mono' },
                bold: 'Bold',
                italic: 'Italic',
                underline: 'Underline',
                boldAbbrev: 'B',
                italicAbbrev: 'I',
                underlineAbbrev: 'U',
            },
            path: {
                startCap: 'Start cap',
                endCap: 'End cap',
                style: 'Line style',
                width: 'Width (×)',
                anchor: 'Anchor {{n}}',
                bound: 'attached to a stitch',
                free: 'free',
            },
            caps: {
                none: 'None',
                arrow: 'Arrow',
                dot: 'Dot',
                bar: 'Bar',
            },
            styles: {
                solid: 'Solid',
                dashed: 'Dashed',
                dotted: 'Dotted',
            },
            bezier: {
                edit: 'Edit shape',
                addAnchor: 'Add anchor',
                removeAnchor: 'Remove anchor',
                handles: 'Handles',
            },
            handleTypes: { aligned: 'Aligned', vector: 'Vector', free: 'Free' },
            handleSides: { left: 'Left', right: 'Right' },
        },

        annotationActionRail: {
            undo: 'Undo',
            redo: 'Redo',
            delete: 'Delete',
            duplicate: 'Duplicate',
        },

        annotationToolbar: {
            editingCurve: 'Editing curve',
            editingCircle: 'Editing circle',
            editingArc: 'Editing arc',
            editingText: 'Editing text',
            exitEditMode: 'Exit edit mode',
            color: 'Annotation color',
        },

        annotationTextEditor: {
            label: 'Annotation text',
        },

        // Crochet editor floating toolbars (top tool/mode bar + bottom chain-edit panel)
        crochetToolbar: {
            stitch: 'Stitch',
            stitchTool: 'Stitch tool',
            guide: 'Guide',
            guideTool: 'Guide tool',
            place: 'Place',
            edit: 'Edit',
            chain: 'Chain',
            chainTooltip: 'Chain (move/rotate)',
            sizing: 'Sizing',
            sizingTooltip: 'Resize chain ellipse width',
            advanced: 'Advanced',
            advancedTooltip: 'Adjust cap/crossbar angle and crossbar position',
            editingGuide: 'Editing guide',
            exitEditMode: 'Exit',
        },

        // Order mode (SP-48): number the stitches of a round by clicking them in order
        crochetOrderPick: {
            button: 'Number stitches in a round',
            setupTitle: 'Number stitches in a round',
            round: 'Round',
            roundPlaceholder: 'Choose a round',
            roundOption_one: 'Round {{round}} ({{count}} stitch)',
            roundOption_other: 'Round {{round}} ({{count}} stitches)',
            noRounds: 'No rounds yet. Give stitches a round first.',
            roundHint: 'Or click any stitch on the canvas to use its round.',
            start: 'First stitch you click gets',
            cancel: 'Cancel',
            begin: 'Start numbering',
            barTitle: 'Numbering round {{round}}',
            next: 'Next click gets',
            progress: '{{count}} of {{total}} numbered',
            undoLast: 'Undo last',
            apply: 'Apply',
            undo: 'Undo',
            notice: {
                'other-round': "That stitch isn't in this round.",
                'already-picked': 'That stitch already has a number. Use Undo last to step back.',
                'no-round': "That stitch doesn't belong to a round yet.",
                'last-number': 'Last number reached. Press Enter to apply.',
            },
            toastCleared_one: 'Numbered stitches {{from}}–{{to}} in round {{round}}. Cleared the order on {{count}} stitch that already had one of those numbers; it’s numbered automatically now.',
            toastCleared_other: 'Numbered stitches {{from}}–{{to}} in round {{round}}. Cleared the order on {{count}} stitches that already had those numbers; they’re numbered automatically now.',
            toastClearedSingle_one: 'Numbered stitch {{from}} in round {{round}}. Cleared the order on {{count}} stitch that already had that number; it’s numbered automatically now.',
            toastClearedSingle_other: 'Numbered stitch {{from}} in round {{round}}. Cleared the order on {{count}} stitches that already had that number; they’re numbered automatically now.',
        },

        crochetActionToolbar: {
            undo: 'Undo',
            redo: 'Redo',
            copy: 'Copy',
            paste: 'Paste',
            pasteWithStitches: 'Paste with snapped stitches',
            pasteWithStructure: 'Paste with stitch structure',
            duplicate: 'Duplicate (repeat last action)',
            delete: 'Delete',
            alignDirection: 'Align direction',
            alignDirectionHint: 'Draw a line to set the direction',
            toastDirectionLineAligned: 'Aligned {{applied}} — {{skipped}} skipped (guide-snapped or no direction).',
            toastDirectionLineAlignedNone: 'No stitches aligned — {{skipped}} skipped (guide-snapped or no direction).',
            link: 'Link stitches',
        },

        gridActionToolbar: {
            undo: 'Undo',
            redo: 'Redo',
        },

        // Stitch names
        stitch: {
            purl: 'Purl',
            knitBar: 'Knit (bar)',
            purlBar: 'Purl (bar)',
            slip: 'Slip',
            slipWyif: 'Slip wyif',
            slipWyifCross: 'Slip wyif (cross)',
            slipWyifFilled: 'Slip wyif (filled)',
            slipWyifFilledBar: 'Slip wyif (filled bar)',
            knitTbl: 'Knit tbl',
            purlTbl: 'Purl tbl',
            purlTblBar: 'Purl tbl (bar)',
            knitTblArrow: 'Knit tbl (arrow)',
            purlTblArc: 'Purl tbl (arc)',
        },

        // Crochet — stitch names + editor-selection strings
        crochet: {
            chainUp: 'Chain (vertical)',
            chainCenter: 'Chain (horizontal)',
            slipStitch: 'Slip stitch',
            singleCrochetX: 'Single crochet (×)',
            singleCrochetCrosshair: 'Single crochet (crosshair)',
            halfDoubleCrochet: 'Half double crochet',
            title: 'Crochet',
        },

        // Crochet rail item descriptors
        crochetRail: {
            stitch: {
                'double-crochet': 'Double crochet',
                'half-double-crochet': 'Half double crochet',
                'treble-crochet': 'Treble crochet',
                'double-treble-crochet': 'Double treble crochet',
                'chain': 'Chain',
                'chain-full': 'Chain (full)',
                'single-crochet': 'Single crochet',
                'single-crochet-full': 'Single crochet (full)',
                'single-crochet-x': 'Single crochet (×)',
                'single-crochet-x-full': 'Single crochet (× full)',
                'single-crochet-directional': 'Single crochet (directional)',
                'single-crochet-directional-full': 'Single crochet (directional, full)',
                'reverse-single-crochet': 'Reverse single crochet',
                'reverse-single-crochet-full': 'Reverse single crochet (full)',
                'reverse-single-crochet-x': 'Reverse single crochet (×)',
                'reverse-single-crochet-x-full': 'Reverse single crochet (× full)',
                'twisted-single-crochet': 'Twisted single crochet',
                'twisted-single-crochet-full': 'Twisted single crochet (full)',
                'twisted-single-crochet-x': 'Twisted single crochet (×)',
                'twisted-single-crochet-x-full': 'Twisted single crochet (× full)',
                'slip-stitch': 'Slip stitch',
                'cluster': 'Cluster',
                'popcorn': 'Popcorn',
                'front-post-single-crochet': 'Front post single crochet',
                'front-post-half-double-crochet': 'Front post half double crochet',
                'front-post-double-crochet': 'Front post double crochet',
                'front-post-treble-crochet': 'Front post treble crochet',
                'front-post-double-treble-crochet': 'Front post double treble crochet',
                'back-post-single-crochet': 'Back post single crochet',
                'back-post-half-double-crochet': 'Back post half double crochet',
                'back-post-double-crochet': 'Back post double crochet',
                'back-post-treble-crochet': 'Back post treble crochet',
                'back-post-double-treble-crochet': 'Back post double treble crochet',
            },
            increase: 'Increase — single crochet',
            decrease: 'Decrease — single crochet',
            guide: {
                'line': 'Line',
                'concentric-circles': 'Concentric circles',
                'magic-ring': 'Magic ring',
                'concentric-arcs': 'Concentric arcs',
                'bezier-curve': 'Bézier curve',
            },
            asym: {
                increase: {
                    'single-crochet': 'Increase — single crochet',
                    'double-crochet': 'Increase — double crochet',
                    'half-double-crochet': 'Increase — half double crochet',
                    'treble-crochet': 'Increase — treble crochet',
                    'double-treble-crochet': 'Increase — double treble crochet',
                    'front-post-single-crochet': 'Increase — front post single crochet',
                    'front-post-half-double-crochet': 'Increase — front post half double crochet',
                    'front-post-double-crochet': 'Increase — front post double crochet',
                    'front-post-treble-crochet': 'Increase — front post treble crochet',
                    'front-post-double-treble-crochet': 'Increase — front post double treble crochet',
                    'back-post-single-crochet': 'Increase — back post single crochet',
                    'back-post-half-double-crochet': 'Increase — back post half double crochet',
                    'back-post-double-crochet': 'Increase — back post double crochet',
                    'back-post-treble-crochet': 'Increase — back post treble crochet',
                    'back-post-double-treble-crochet': 'Increase — back post double treble crochet',
                },
                decrease: {
                    'single-crochet': 'Decrease — single crochet',
                    'double-crochet': 'Decrease — double crochet',
                    'half-double-crochet': 'Decrease — half double crochet',
                    'treble-crochet': 'Decrease — treble crochet',
                    'double-treble-crochet': 'Decrease — double treble crochet',
                    'front-post-single-crochet': 'Decrease — front post single crochet',
                    'front-post-half-double-crochet': 'Decrease — front post half double crochet',
                    'front-post-double-crochet': 'Decrease — front post double crochet',
                    'front-post-treble-crochet': 'Decrease — front post treble crochet',
                    'front-post-double-treble-crochet': 'Decrease — front post double treble crochet',
                    'back-post-single-crochet': 'Decrease — back post single crochet',
                    'back-post-half-double-crochet': 'Decrease — back post half double crochet',
                    'back-post-double-crochet': 'Decrease — back post double crochet',
                    'back-post-treble-crochet': 'Decrease — back post treble crochet',
                    'back-post-double-treble-crochet': 'Decrease — back post double treble crochet',
                },
                flyoutTitle: 'Increases & decreases',
                increaseSection: 'Increase',
                decreaseSection: 'Decrease',
                more: 'All increases & decreases',
                pin: 'Pin to rail',
                unpin: 'Remove from rail',
            },
            scrollUp: 'Scroll up',
            scrollDown: 'Scroll down',
            moreStitches: 'All stitches',
            category: {
                all: 'All',
                basic: 'Basic',
                posts: 'Posts',
                clusters: 'Clusters',
                textured: 'Textured',
                special: 'Special',
            },
            flyout: {
                title: 'Stitches',
                searchPlaceholder: 'Search stitches…',
                noResults: 'No stitches match your search.',
                pin: 'Pin to rail',
                unpin: 'Remove from rail',
            },
        },

        crochetPieMenu: {
            scGroup: 'Single crochet…',
            incDecGroup: 'Increase / decrease…',
            postsGroup: 'Front post…',
            backPostsGroup: 'Back post…',
        },

        // App navigation
        nav: {
            menuLabel: 'Open navigation menu',
            home: 'Home',
            knit: 'Knit',
            crochet: 'Crochet',
            help: 'Help',
            feedback: 'Send feedback',
        },


        // Landing page
        landing: {
            tagline: 'A visual knitting pattern editor.',
            openEditor: 'Open Editor',
            knitTitle: 'Knit',
            knitDescription: 'Design knitting charts on a grid.',
            crochetTitle: 'Crochet',
            crochetDescription: 'Design crochet patterns with stitch icons.',
            patternTitle: 'Pattern',
            patternDescription:
                'Compose a written pattern with text and diagrams.',
        },

        // The installed offline app's first start: the work the install page copied across is imported before the app shows.
        offlineBoot: {
            copying: 'Copying your work… {{done}} / {{total}}',
            copyFailed: "Couldn't copy your work. It will be tried again the next time {{appName}} starts.",
        },

        // A code to copy: the button, and the code itself in a field when the browser will not copy it.
        copyCode: {
            copied: 'Copied',
            fallback: 'Copy this code:',
        },

        // Offline site (the paid offline app's own origin: landing, install and update pages)
        offlineSite: {
            landing: {
                title: '{{appName}} offline app',
                getIt: 'Get it from {{appName}} → Settings → Offline app.',
            },
            // The install page, and the parts of the update page that read the same.
            install: {
                title: 'Install {{appName}}',
                preparing: 'Preparing the download…',
                progress:
                    'Downloading {{appName}} {{version}}… {{done}} / {{total}} files',
                ready: 'Ready — works without internet',
                installButton: 'Install app',
                openNow: 'Open now',
                safariDock: 'File → Add to Dock',
                iosHomeScreen: 'Share → Add to Home Screen',
                bookmark: 'Ready in this tab — bookmark it.',
                retry: 'Try again',
                // The first-install handover: the user's work coming over from the Settings tab.
                copyingStart: 'Copying your work from {{appName}}…',
                copying: 'Copying your work from {{appName}}… {{done}} / {{total}}',
                skip: 'Skip',
                workCopied_one: 'Your work was copied ({{count}} item).',
                workCopied_other: 'Your work was copied ({{count}} items).',
                workNotCopied: "Your work wasn't copied. You can import it later from Settings → Your data.",
                // Safari's Dock apps and iOS Home Screen apps: the page asks to add the app, and the app finishes installing.
                openFromDock: 'Open {{appName}} from the Dock. It finishes installing there.',
                openFromHomeScreen: 'Open {{appName}} from your Home Screen. It finishes installing there.',
                copyInstallCode: 'Copy install code',
                installedInApp: 'Installed',
                importHintInApp:
                    'To bring your work, use Export all in {{appName}} in Safari (Settings → Your data), then Import here.',
            },
            // The installed Safari app's first start: it asks for the install code that the Safari tab could not pass on.
            finish: {
                title: 'Finish installing {{appName}}',
                pasteLabel: 'Paste install code',
                continue: 'Continue',
                notACode: "That isn't an install code.",
                expired: 'This code has expired. Get a new one in {{appName}} → Settings → Offline app.',
            },
            update: {
                title: 'Update {{appName}}',
                ready: 'Updated — opening {{appName}}…',
            },
            // One message per way an install or update can fail.
            errors: {
                expired:
                    'This link expired. Go back to {{appName}} and click Get offline app again.',
                unauthorized:
                    'This link is not valid. Go back to {{appName}} and click Get offline app again.',
                'missing-token':
                    'This page needs an install link. Go back to {{appName}} and click Get offline app.',
                'not-enough-storage':
                    'Not enough space: about {{mb}} MB free needed.',
                network:
                    'The download was interrupted. Check your connection and try again.',
                integrity:
                    'The download did not match what was expected, so it was discarded. Try again.',
                'no-build':
                    'The offline app is not available yet. Please try again later.',
                unsupported:
                    'This browser cannot run the offline app. Try a recent Chrome, Edge, Safari or Firefox.',
            },
        },

        // The signed-in /offline page: the installed offline app's "Check for updates" opens it.
        // `{{from}}` is the installed build, `{{current}}` the build this site serves.
        offlineUpdate: {
            title: 'Update the offline app',
            upToDate: "You're up to date.",
            subscribe: 'Your installed {{from}} keeps working. Subscribe to get {{current}}.',
            // The same, for a visit that did not say which build is installed (no ?from).
            subscribeNoFrom: 'Your installed offline app keeps working. Subscribe to get {{current}}.',
            trial: 'The offline app comes with a paid plan.',
            updating: 'Getting your update ready…',
            unavailable: 'The offline app is not available right now.',
            // The generic failure; the other reasons reuse settingsPage.offlineApp.tokenError.*.
            error: 'Could not start the update. Please try again.',
            // `?handoff=code` (Safari Dock and iOS Home Screen apps): the update code is copied by hand
            // into the offline app instead of the page navigating to the offline site.
            copyUpdateCode: 'Copy update code',
            codeSteps:
                'Paste it in {{appName}} (offline): Settings → Info → Paste update code. The code works for 15 minutes.',
        },

        dashboard: {
            title: 'Your workspace',
            filterAll: 'All',
            filterCrochet: 'Crochet',
            filterKnit: 'Knit',
            filterPatterns: 'Patterns',
            filterArchived: 'Archived',
            bandCrochet: 'Crochet',
            bandKnit: 'Knit',
            bandPatterns: 'Patterns',
            seeAll: 'See all',
            newButton: 'New',
            newCrochet: 'New crochet',
            newKnit: 'New knit',
            newPattern: 'New pattern',
            empty: "Nothing here yet — create your first with New.",
            loadFailed: "Couldn't load your workspace. Please try again.",
            storageUnavailable: 'Storage is unavailable in this browser.',
            importHint: 'Have work in {{appName}} online?',
            importHintLink: 'Import your work',
            // Free plan only: how many of the plan's active-diagram slots are in use.
            counter: '{{used}} of {{limit}} active diagrams',
        },

        notFound: {
            title: 'Looks like we dropped a stitch',
            description: 'This page must have unraveled — it isn’t here anymore.',
            backHome: 'Back to home',
        },

        // Pattern Editor Page
        patternEditor: {
            title: 'Pattern editor',
            description:
                'Compose a written crochet or knitting pattern with rich text and diagrams.',
            textPlaceholder: 'Type your pattern text…',
            fonts: {
                warningTitle: 'A pattern font didn\'t load',
                warningDescription: 'The PDF may use a different font and break pages elsewhere.',
                notice: "{{fonts}} didn't load, so page breaks aren't being saved. Reload once you're back online.",
                warning: "{{fonts}} didn't load: the PDF may break lines and pages differently.",
            },
            legend: {
                insert: 'Insert stitch legend',
                emptyChart: 'This chart has no stitches yet',
                deleteRow: 'Remove row',
                tooLarge: 'This chart has too many stitches for a legend.',
                refreshFromChart: 'Refresh from chart',
                // The data-mode error panel's way out (legend and written instructions alike).
                close: 'Close',
                refreshConfirm: {
                    title: 'Replace your edits?',
                    body: "Refreshing replaces this block with the chart's current stitches. Your edits to it will be lost.",
                    confirm: 'Refresh',
                    cancel: 'Cancel',
                },
            },
            instructions: {
                insert: 'Insert written instructions',
                notesOmitted_one: 'Inserted. {{count}} chart note was left out — check the chart.',
                notesOmitted_other: 'Inserted. {{count}} chart notes were left out — check the chart.',
                emptyChart: 'This chart has no stitches to write out yet',
                notesOmittedRefresh_one: 'Refreshed. {{count}} chart note was left out — check the chart.',
                notesOmittedRefresh_other: 'Refreshed. {{count}} chart notes were left out — check the chart.',
                tooLarge: 'This chart is too large to insert as written instructions.',
            },
            paperErrors: {
                edge: 'Cut off at the paper edge',
                tooTall: 'This paragraph is taller than a page',
                warning: {
                    title: 'Some content will be cut off',
                    description: 'Some content on these pages doesn’t fit on the paper and will be cut off in the PDF.',
                    page: 'Page {{page}}: {{reasons}}',
                    goBack: 'Go back',
                    exportAnyway: 'Export anyway',
                    // Short forms for the per-page list, which joins them mid-sentence.
                    reasons: {
                        edge: 'cut off at the paper edge',
                        tooTall: 'a paragraph taller than a page',
                    },
                },
            },
            exportPdf: 'Export PDF',
            addText: 'Add text box',
            addImage: 'Add image',
            addDiagram: 'Add diagram',
            resizeElement: 'Resize element',
            language: {
                label: 'Pattern language',
            },
            snap: {
                button: 'Snap',
                hint: 'Snap to page edges, margins and other elements. Hold Cmd or Ctrl while dragging to place freely.',
            },
            // Align, distribute and select (SP-149, SP-150). Distinct from text alignment.
            arrange: {
                title: 'Arrange',
                alignLeft: 'Align left',
                alignCentre: 'Align centre',
                alignRight: 'Align right',
                alignTop: 'Align top',
                alignMiddle: 'Align middle',
                alignBottom: 'Align bottom',
                distributeH: 'Distribute horizontally',
                distributeV: 'Distribute vertically',
                toSelection: 'Align to selection',
                toPage: 'Align to page',
                selectMode: 'Select',
                selectMore: 'Select more',
            },
            // The running header and footer dialog (SP-144). {page}, {pages} and {name} stay literal in every language.
            headerFooter: {
                button: 'Header & footer',
                title: 'Header and footer',
                description: 'Shown on every page of this pattern, in the margins.',
                header: 'Header',
                footer: 'Footer',
                left: 'Left',
                center: 'Centre',
                right: 'Right',
                insertPage: 'Page number',
                insertPages: 'Page count',
                insertName: 'Pattern name',
                insertPreset: 'Page 1 of 5',
                hint: '{page}, {pages} and {name} become the page number, the page count and the pattern name.',
                hideOnFirstPage: 'Hide on the first page (cover)',
                preview: 'Preview',
                previewPage: 'Page {{number}}',
                done: 'Done',
                cancel: 'Cancel',
            },
            margins: {
                button: 'Margins',
                title: 'Page margins',
                description: 'The space around the content on every page. Blocks stay where they are; text reflows.',
                top: 'Top',
                right: 'Right',
                bottom: 'Bottom',
                left: 'Left',
                unitIn: 'in',
                unitMm: 'mm',
                invalid: 'Margins must be zero or more, and leave at least 1 in (25 mm) of room for content across and down.',
                invalidBand: 'The top and bottom margins must be at least 0.25 in (6.4 mm) while the pattern has a header or footer.',
                apply: 'Apply',
                cancel: 'Cancel',
            },
            paperSize: {
                label: 'Paper size',
                letter: 'Letter (8.5 × 11 in)',
                a4: 'A4 (210 × 297 mm)',
            },
            menu: {
                cut: 'Cut',
                copy: 'Copy',
                paste: 'Paste',
                delete: 'Delete',
                duplicate: 'Duplicate',
                bringToFront: 'Bring to front',
                bringForward: 'Bring forward',
                sendBackward: 'Send backward',
                sendToBack: 'Send to back',
                refreshDiagram: 'Refresh from diagram',
            },
            pages: {
                label: 'Page {{number}}',
                actions: 'Page {{number}} actions',
                add: 'Add page',
                newPageSlot: 'Drop here for a new page',
                addAfter: 'Add page after',
                moveUp: 'Move page up',
                moveDown: 'Move page down',
                delete: 'Delete page',
                deleteTitle: 'Delete page {{number}}?',
                deleteBody_one: 'The block on this page will be deleted too.',
                deleteBody_other: 'The {{count}} blocks on this page will be deleted too.',
                cancel: 'Cancel',
                confirmDelete: 'Delete page',
            },
            zoom: {
                in: 'Zoom in',
                out: 'Zoom out',
                fitPage: 'Fit page',
                fitWidth: 'Fit width',
                level: 'Zoom level',
            },
            textFlow: {
                continuation: 'Continued text. Drag to move it on this page, or drag its edges to resize it.',
                resetContinuation: 'Reset position and size',
            },
            history: {
                undoStep: 'Undo {{step}}',
                redoStep: 'Redo {{step}}',
                steps: {
                    addText: 'add text box',
                    addImage: 'add image',
                    insertChart: 'insert chart',
                    refreshChart: 'refresh chart',
                    insertLegend: 'insert legend',
                    editLegend: 'edit legend',
                    refreshLegend: 'refresh legend',
                    insertInstructions: 'insert instructions',
                    refreshInstructions: 'refresh instructions',
                    move: 'move',
                    resize: 'resize',
                    moveContinuation: 'move continuation',
                    resizeContinuation: 'resize continuation',
                    resetContinuation: 'reset continuation',
                    editText: 'text edit',
                    delete: 'delete',
                    duplicate: 'duplicate',
                    bringToFront: 'bring to front',
                    paperSize: 'paper size',
                    patternLanguage: 'pattern language',
                    headerFooter: 'header and footer',
                    addPage: 'add page',
                    deletePage: 'delete page',
                    movePage: 'move page',
                    bringForward: 'bring forward',
                    sendBackward: 'send backward',
                    sendToBack: 'send to back',
                    align: 'align',
                    distribute: 'distribute',
                    nudge: 'nudge',
                    nudgeContinuation: 'nudge continuation',
                    margins: 'margins',
                },
            },
            toolbar: {
                undo: 'Undo',
                redo: 'Redo',
                blockType: 'Text style',
                blockNormal: 'Normal',
                blockH1: 'Heading 1',
                blockH2: 'Heading 2',
                blockH3: 'Heading 3',
                blockBullet: 'Bullet list',
                blockNumbered: 'Numbered list',
                blockCheck: 'Check list',
                blockQuote: 'Quote',
                blockCode: 'Code block',
                fontFamily: 'Font',
                fontSize: 'Font size',
                decreaseFontSize: 'Decrease font size',
                increaseFontSize: 'Increase font size',
                bold: 'Bold',
                italic: 'Italic',
                underline: 'Underline',
                code: 'Inline code',
                link: 'Insert link',
                bulletList: 'Bullet list',
                numberedList: 'Numbered list',
                moreFormats: 'More text formats',
                strikethrough: 'Strikethrough',
                subscript: 'Subscript',
                superscript: 'Superscript',
                clearFormatting: 'Clear formatting',
                textColor: 'Text color',
                bgColor: 'Background color',
                customColor: 'Custom color',
                align: 'Alignment',
                alignLeft: 'Align left',
                alignCenter: 'Align center',
                alignRight: 'Align right',
                alignJustify: 'Justify',
                indent: 'Indent',
                outdent: 'Outdent',
                linkPrompt: 'Enter URL:',
                scrollLeft: 'Scroll toolbar left',
                scrollRight: 'Scroll toolbar right',
            },
            pdfExport: {
                preparing: 'Preparing PDF…',
                ready: 'Your PDF is ready.',
                save: 'Save PDF',
                offlineFallback: 'PDF files need a connection to {{appName}}. Opening the print dialog instead — choose “Save as PDF”.',
                failedFallback: 'Couldn’t create the PDF file. Opening the print dialog instead — choose “Save as PDF”.',
            },
        },

        // Grid stitch pie menu
        gridPieMenu: {
            knit: 'Knit',
            purl: 'Purl',
            'knit-bar': 'Knit (bar)',
            'purl-bar': 'Purl (bar)',
            empty: 'Empty',
            slipGroup: 'Slip…',
            slip: 'Slip',
            'slip-wyif': 'Slip wyif',
            'slip-wyif-cross': 'Slip wyif cross',
            'slip-wyif-filled': 'Slip wyif filled',
            'slip-wyif-filled-bar': 'Slip wyif filled (bar)',
            tblGroup: 'Through back loop…',
            'knit-tbl': 'Knit tbl',
            'purl-tbl': 'Purl tbl',
            'purl-tbl-bar': 'Purl tbl (bar)',
            'knit-tbl-arrow': 'Knit tbl arrow',
            'purl-tbl-arc': 'Purl tbl arc',
        },

        // Icon Handoff Page
        iconHandoff: {
            title: 'Icon Handoff',
            intro: 'This page lists every icon used in the app. Designers can drop replacement SVGs into',
            introCode: 'public/designer-icons/<slug>/<slug>.svg',
            introClosing: ' and they will appear in the "Designer" column.',
            conventionTitle: 'Convention',
            conventionBody:
                'All icons are imported from @/assets/icons. Custom first-party SVG icons go in src/assets/icons/ as React components. Lucide icons are re-exported from a single lucide.ts file.',
            sectionCustomTitle: 'Custom App Icons',
            sectionCustomSubtitle: 'First-party React SVG components.',
            sectionLucideTitle: 'Lucide Icons',
            sectionLucideSubtitle:
                'Re-exported from lucide-react. Do not import lucide-react directly elsewhere.',
            sectionCursorsTitle: 'Cursors',
            sectionCursorsSubtitle:
                'SVG masters in src/assets/cursors/, rasterized to 32px/64px PNGs in public/cursors/ by scripts/build-cursors.sh. The hotspot is the active pixel in @1x coordinates, defined in src/cursors/cursor-registry.ts.',
            tableName: 'Export Name',
            tableState: 'State',
            tableCurrent: 'Current',
            tableDesigner: 'Designer',
            tableHotspot: 'Hotspot',
            tableUsedFor: 'Used For',
            footer: 'To add a new icon, export it from src/assets/icons/index.ts and add a row to icon-handoff-data.ts.',
        },

    },
} as const;

export default en;
